"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("./StarRating.scss");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styles = require("../../styles");

var _utils = require("../../utils");

var _Icons = require("../Icons");

var _InputErrorMessage = require("../Inputs/InputErrorMessage");

var _InputErrorMessage2 = _interopRequireDefault(_InputErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var StarRating =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(StarRating, _PureComponent);

  function StarRating() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, StarRating);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(StarRating)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      selectedStar: ''
    };

    _this.onClickStar = function (e) {
      var starValue = e.currentTarget.getAttribute("value") || '';

      _this.props.onClick(starValue);

      _this.setState({
        selectedStar: starValue
      });
    };

    return _this;
  }

  _createClass(StarRating, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var className = 'c-StarRating';
      var _this$props = this.props,
          starObjects = _this$props.starObjects,
          error = _this$props.error,
          errorMessage = _this$props.errorMessage,
          onBlur = _this$props.onBlur,
          id = _this$props.id;
      var iconColor = _styles.colors.primaryColor;
      return _react2.default.createElement("div", {
        className: "".concat(className, "__starsRow")
      }, _react2.default.createElement(_InputErrorMessage2.default, {
        error: error,
        errorMessage: errorMessage,
        onBlur: onBlur
      }), starObjects.map(function (star) {
        return _react2.default.createElement("div", {
          className: "".concat(className, "__individualStar"),
          id: id,
          name: star.value,
          key: "StarRating__".concat(star.value),
          onClick: _this2.onClickStar,
          value: star.value,
          tabIndex: 0
        }, _react2.default.createElement("div", {
          className: "".concat(className, "__buttonIcon")
        }, _this2.state.selectedStar >= star.value ? _react2.default.createElement(_Icons.StarSolidIcon, {
          className: "".concat(className, "__star"),
          color: iconColor
        }) : _react2.default.createElement(_Icons.StarOutlineIcon, {
          className: "".concat(className, "__star"),
          color: iconColor
        })), star.label);
      }));
    }
  }]);

  return StarRating;
}(_react.PureComponent);

StarRating.defaultProps = {
  error: false,
  numberOfStars: 5,
  onClick: _utils.noop,
  id: null,
  starObjects: [{
    label: '1',
    value: '1'
  }, {
    label: '2',
    value: '2'
  }, {
    label: '3',
    value: '3'
  }, {
    label: '4',
    value: '4'
  }, {
    label: '5',
    value: '5'
  }]
};
exports.default = StarRating;